<template>
	<div class="height-100dvh">
		<main v-show="!showLoaderModal" class="aio-interview-container">
			<div
				id="hideinmobile"
				class="cand-header d-flex justify-content-between mb-2"
			>
				<div>
					{{
						pollFinalResult
							? pollFinalResult.interviewName
							: "Test Name AI summarized"
					}}
				</div>
				<div class="timer-class">{{ formattedTime }}</div>
			</div>
			<div class="aio-container" :class="{ 'no-gap': expandLeft }">
				<div class="left-box" :class="{ expanded: expandLeft }">
					<div
						id="hideinlaptop"
						class="d-flex justify-content-between w-100 fam-lato fw-LM fs-14 text-white head"
					>
						<div class="w-100 text-truncate">
							{{
								pollFinalResult
									? pollFinalResult.interviewName
									: "Interview name generated by AI depending on skills and everything"
							}}
						</div>
						<div class="fs-16">{{ formattedTime }}</div>
					</div>
					<article>
						<div class="lap-mob">
							<video
								id="localVideo"
								class="local-video h-100"
								autoplay
								playsinline
								muted
							></video>
							<div v-if="!cameraEnabled" class="video-cover h-100">
								<div class="avatar-container">
									<img
										v-if="userAvatar"
										:src="userAvatar"
										alt="User Avatar"
										class="user-avatar"
									/>
									<AudioVisualizer :id="'localVideo'" :isLocal="true" />
								</div>
							</div>
						</div>
					</article>
					<!-- <img
						@click="expandLeft = !expandLeft"
						class="expand pointer"
						src="../../assets/img/aiInterview/enlarge-video.svg"
						alt=""
					/> -->
					<div class="control-panel">
						<img
							class="pointer"
							src="../../assets/img/aiInterview/end-call.svg"
							alt=""
							@click="endCall(true)"
						/>
						<img
							v-if="cameraEnabled"
							class="pointer"
							src="../../assets/img/aiInterview/grey-video.svg"
							alt=""
							@click="toggleCamera"
						/>
						<img
							v-else
							class="pointer"
							src="../../assets/img/aiInterview/red-video.svg"
							alt=""
							@click="toggleCamera"
						/>
						<img
							v-if="micEnabled"
							class="pointer"
							src="../../assets/img/aiInterview/grey-mic.svg"
							alt=""
							@click="toggleMic"
						/>
						<img
							v-else
							class="pointer"
							src="../../assets/img/aiInterview/red-mic.svg"
							alt=""
							@click="toggleMic"
						/>
						<!-- <img
							class="pointer"
							src="../../assets/img/aiInterview/grey-cc.svg"
							alt=""
						/> -->
						<!-- <div id="hideinlaptop" class="user-talk-box for-left">
							<img src="../../assets/img/aiInterview/red-waves.svg" alt="" />
							<span class="fam-mont fw-M fs-16 text-grey"
								>Waiting for your answer</span
							>
						</div> -->
					</div>
					<div class="cand-name fam-mont fw-LM fs-16 mob-fs-12 text-white">
						{{ userInfo.username }}
						<img
							v-if="!micEnabled"
							src="../../assets/img/aiInterview/muted.svg"
							alt=""
						/>
					</div>
					<div class="bot-card">
						<!-- <img
							style="position: absolute; right: 12px; top: 12px"
							src="../../assets/img/aiInterview/collapse-video.svg"
							alt=""
						/> -->
						<video
							v-if="remoteStreamConnected"
							id="remoteVideo"
							class="remote-video"
							autoplay
							playsinline
						></video>
						<div v-else class="bot-avatar-container">
							<img
								class="bot"
								src="../../assets/img/aiInterview/bot.svg"
								alt=""
							/>
							<AudioVisualizer
								v-if="remoteStreamConnected"
								:id="'remoteVideo'"
								:isLocal="false"
							/>
						</div>
						<div class="fam-mont fw-M fs-16 mob-fs-12 text-white pb-10">
							Interviewer
						</div>
						<!-- <div class="bot-name fam-mont fw-LM fs-14 text-white">
							Interview Bot
						</div> -->
					</div>
				</div>
				<div class="right-box" :class="{ collapsed: expandLeft }">
					<div class="right-overflow">
						<div
							v-if="transcripts.length === 0"
							class="text-center fam-lato fw-R fs-14 text-9aa5b1 py-4"
						>
							No transcripts yet. The interviewer's messages will appear here.
						</div>
						<div
							v-for="(transcript, index) in transcripts"
							:key="index"
							class="d-flex gap-2"
						>
							<img
								height="44"
								src="../../assets/img/aiInterview/bot.svg"
								alt=""
							/>
							<div>
								<div>
									<span class="fam-mont fw-B fs-13 text-darkgrey"
										>Interview Bot</span
									><span class="fam-lato fw-R fs-12 text-9aa5b1 ml-2">{{
										transcript.time
									}}</span>
								</div>
								<div class="text-box fam-lato mt-2">
									{{ transcript.text }}
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="user-talk-box">
						<img src="../../assets/img/aiInterview/red-waves.svg" alt="" />
						<span class="fam-mont fw-M fs-16 text-grey"
							>Waiting for your answer</span
						>
					</div> -->
				</div>
			</div>
		</main>
		<div
			style="background-color: rgba(0, 0, 0, 0.1); backdrop-filter: blur(5px)"
			v-if="showLoaderModal"
			class="position-absolute h-100 w-100 d-flex align-items-center justify-content-center"
		>
			<Spinner :id="'modal'" :loaderText="loaderText" />
		</div>
		<!-- Inactivity Warning Modal -->
		<div v-if="showInactivityWarning" class="inactivity-modal-overlay">
			<div class="inactivity-modal">
				<div class="inactivity-icon">
					<img
						src="../../assets/newdesign/BecomePanelist/yellowalert-doubleLayer.svg"
						alt=""
					/>
				</div>
				<h2 class="inactivity-title">Inactivity Detected</h2>
				<p class="inactivity-message">
					We haven't detected any activity. The interview will end in:
				</p>
				<div class="countdown-box">
					<div class="countdown-timer">
						{{ formattedCountdown }}
					</div>
				</div>
				<b-button class="candash-addBtn" @click="dismissInactivityWarning">
					I'm Here - Continue Interview
				</b-button>
			</div>
		</div>
		<!-- Pre fetch user avatar -->
		<img style="display: none" :src="userAvatar" alt="User Avatar" />
	</div>
</template>

<script>
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import Peer from "peerjs";
import LoaderModal from "@/components/fixedcomponents/LoaderModal.vue";
import AudioVisualizer from "@/components/AudioVisualizer.vue";
import {
	pollMockInterviewStatus,
	getParticipantAvatar,
} from "@/utils/apiFunctions";
import { mapGetters } from "vuex";
export default {
	components: {
		LoaderModal,
		Spinner,
		AudioVisualizer,
	},
	data() {
		return {
			initialElapsedMs: null,
			performanceNow: null,
			startTime: null,
			performanceNowInterval: null,
			expandLeft: false,
			interviewID: this.$route.params.interviewID,
			interviewerPeerID: null,
			peer: null,
			localStream: null,
			remoteStream: null,
			call: null,
			cameraEnabled: true,
			micEnabled: true,
			remoteStreamConnected: false,
			transcripts: [],
			botAudio: null,
			mockInterviewStatus: 0,
			mockInterviewStatusText: {
				// Initialzing
				0: [
					"Reviewing Your Details",
					"Preparing Interview Questions",
					"Setting Up Evaluation",
					"Starting Your Mock Interview",
				],
				// Completed
				2: [
					"Comparing your responses with best practices",
					"Scoring your overall performance",
					"Preparing personalized recommendations",
					"Creating your detailed feedback report",
				],
			},
			showInactivityWarning: false,
			inactivityCountdown: 60,
			inactivityCountdownInterval: null,
			clientDataChannel: null,
			userAvatar: null,
			pollFinalResult: null,
		};
	},
	async mounted() {
		document.addEventListener("beforeunload", () => {
			this.cleanup();
			this.clearInactivityTimer();
		});
		await this.initializePeer();
		await this.startLocalStream();
		await this.startMockInterview();
		await this.getUserAvatar();
	},
	beforeDestroy() {
		this.cleanup();
		this.clearInactivityTimer();
		document.removeEventListener("beforeunload", () => {
			this.cleanup();
			this.clearInactivityTimer();
		});
	},
	methods: {
		async initializePeer() {
			const config = {
				host: process.env.VUE_APP_PEERJS_HOST,
				port: 443,
				path: "/peerjs",
				secure: true,
				config: {
					iceServers: [
						{
							urls: "stun:stun.hire3x.com:3478",
						},
						{
							urls: [
								"turn:stun.hire3x.com:3478?transport=tcp",
								"turns:stun.hire3x.com:5349",
							],
							username: "hire3x",
							credential: "hire3x123",
						},
					],
				},
			};

			return new Promise((resolve, reject) => {
				this.peer = new Peer(undefined, config);

				this.peer.on("open", (id) => {
					console.log("My peer ID is: " + id);
					resolve(id);
				});

				this.peer.on("error", (error) => {
					console.error("Peer error:", error);
					reject(error);
				});
			});
		},

		async startLocalStream() {
			const constraints = {
				audio: {
					sampleRate: 16000,
					channelCount: 1,
					sampleSize: 8,
					echoCancellation: true,
					noiseSuppression: true,
					autoGainControl: true,
				},
				video: {
					facingMode: "user",
					width: { ideal: 640 },
					height: { ideal: 360 },
					frameRate: { ideal: 15 },
				},
			};

			try {
				const stream = await navigator.mediaDevices.getUserMedia(constraints);
				this.localStream = stream;

				const video = document.getElementById("localVideo");
				if (video) {
					video.srcObject = stream;
				}
			} catch (error) {
				console.error("Error accessing media devices:", error);
				alert("Unable to access camera/microphone. Please grant permissions.");
			}
		},

		async startMockInterview() {
			this.interviewerPeerID = await this.pollForPeerID();
			if (this.interviewerPeerID && this.localStream) {
				this.callInterviewer();
			}
		},

		async pollForPeerID() {
			while (!this.interviewerPeerID) {
				try {
					const response = await pollMockInterviewStatus(this.interviewID);
					if (response.data.status != "running") {
						this.endCall();
					}
					if (response.data.peerId) {
						this.pollFinalResult = response.data;
						return response.data.peerId;
					} else {
						await new Promise((resolve) => setTimeout(resolve, 2000));
					}
				} catch (error) {
					console.error(error);
					this.endCall();
					break;
				}
			}
		},

		callInterviewer() {
			if (!this.peer || !this.interviewerPeerID || !this.localStream) {
				console.error(
					"Cannot call: peer, interviewerPeerID, or localStream is missing"
				);
				return;
			}

			console.log("Calling interviewer:", this.interviewerPeerID);
			this.call = this.peer.call(this.interviewerPeerID, this.localStream);
			window.call = this.call;

			// Setup data channels for transcripts
			this.setupDataChannels();

			this.call.on("stream", (remoteStream) => {
				console.log("Received remote stream");
				this.remoteStream = remoteStream;

				// Setup video display
				const remoteVideo = document.getElementById("remoteVideo");
				if (remoteVideo) {
					remoteVideo.srcObject = remoteStream;
					this.remoteStreamConnected = true;
				}

				// Setup audio playback
				this.setupAudioPlayback(remoteStream);
				this.mockInterviewStatus = this.MOCK_INTERVIEW_STATUS.ONGOING;
			});

			this.call.on("close", () => {
				console.log("Call closed");
				this.remoteStreamConnected = false;
				this.stopAudioPlayback();
			});

			this.call.on("error", (error) => {
				console.error("Call error:", error);
				this.stopAudioPlayback();
			});
		},

		setupAudioPlayback(stream) {
			// Create audio element for playback
			if (!this.botAudio) {
				this.botAudio = new Audio();
				this.botAudio.autoplay = true;
				this.botAudio.volume = 0.7;
			}
			this.botAudio.srcObject = stream;
			console.log("Audio playback initialized");
		},

		stopAudioPlayback() {
			if (this.botAudio) {
				this.botAudio.pause();
				if (this.botAudio.srcObject) {
					this.botAudio.srcObject.getTracks().forEach((track) => {
						track.stop();
					});
				}
				this.botAudio.srcObject = null;
				this.botAudio = null;
			}
		},

		setupDataChannels() {
			const initDataChannel = () => {
				if (this.call && this.call.peerConnection) {
					try {
						const channel = this.call.peerConnection.createDataChannel(
							"transcript",
							{
								ordered: true,
							}
						);

						this.clientDataChannel = channel;

						channel.onopen = () => {
							console.log("Data channel opened for transcripts");
						};

						channel.onmessage = (event) => {
							try {
								const data = JSON.parse(event.data);
								if (
									data.type === "transcript_history" &&
									Array.isArray(data.transcripts)
								) {
									this.transcripts = data.transcripts.map((t) => {
										const timestamp = new Date(t.timestamp || Date.now());
										const timeString = timestamp.toLocaleTimeString([], {
											hour: "2-digit",
											minute: "2-digit",
										});
										return { text: t.transcript, time: timeString };
									});
									console.log(
										`Received transcript history (${data.transcripts.length} entries)`
									);

									// Auto-scroll to bottom
									this.$nextTick(() => {
										const container = document.querySelector(".right-overflow");
										if (container) {
											container.scrollTop = container.scrollHeight;
										}
									});
								} else if (
									data.type === "ai_interviewer_transcript" &&
									data.transcript
								) {
									console.log("Interviewer:", data.transcript);

									const timestamp = new Date(data.timestamp || Date.now());
									const timeString = timestamp.toLocaleTimeString([], {
										hour: "2-digit",
										minute: "2-digit",
									});

									this.transcripts.push({
										text: data.transcript,
										time: timeString,
									});

									// Auto-scroll to bottom
									this.$nextTick(() => {
										const container = document.querySelector(".right-overflow");
										if (container) {
											container.scrollTop = container.scrollHeight;
										}
									});
								} else if (
									data.type === "report_generation_status" &&
									data.status
								) {
									this.endCall();
								} else if (data.type === "inactivity_warning") {
									console.log("⚠️ Inactivity Warning:", data.message);
									this.handleInactivityWarning(data.message);
								} else if (data.type === "inactivity_disconnect") {
									console.log("🔴 Inactivity Disconnect:", data.message);
									this.handleInactivityDisconnect(data.message);
								} else if (data.type === "time_elapsed") {
									this.initialElapsedMs = data.time_elapsed * 1000;
									this.performanceNow = performance.now();
									this.startTime = this.performanceNow;
									this.trackPerformanceNow();
								}
							} catch (error) {
								console.error("Error parsing transcript data:", error);
							}
						};

						channel.onerror = (error) => {
							console.error("Data channel error:", error);
						};

						channel.onclose = () => {
							console.log("Data channel closed");
						};
					} catch (error) {
						console.warn("Could not create data channel:", error);
					}
				} else {
					// Retry after a short delay if peerConnection not ready
					setTimeout(initDataChannel, 100);
				}
			};

			initDataChannel();
		},

		trackPerformanceNow() {
			this.stopPerformanceNowInterval();
			this.performanceNow = performance.now();
			this.performanceNowInterval = setInterval(() => {
				this.performanceNow = performance.now();
			}, 100);
		},
		stopPerformanceNowInterval() {
			if (this.performanceNowInterval) {
				clearInterval(this.performanceNowInterval);
				this.performanceNowInterval = null;
			}
		},

		toggleCamera() {
			if (this.localStream) {
				const videoTracks = this.localStream.getVideoTracks();
				videoTracks.forEach((track) => {
					track.enabled = !track.enabled;
				});
				this.cameraEnabled = !this.cameraEnabled;
			}
		},

		toggleMic() {
			if (this.localStream) {
				const audioTracks = this.localStream.getAudioTracks();
				audioTracks.forEach((track) => {
					track.enabled = !track.enabled;
				});
				this.micEnabled = !this.micEnabled;
			}
		},

		async endCall(callStop = false) {
			if (this.mockInterviewStatus == this.MOCK_INTERVIEW_STATUS.COMPLETED)
				return;
			this.mockInterviewStatus = this.MOCK_INTERVIEW_STATUS.COMPLETED;

			if (callStop) {
				if (
					this.clientDataChannel &&
					this.clientDataChannel.readyState === "open"
				) {
					try {
						console.log(
							"Requesting bot to stop and generate report via data channel..."
						);
						this.clientDataChannel.send(
							JSON.stringify({ type: "stop_interview" })
						);
						console.log("Stop request sent successfully via data channel");
						await new Promise((resolve) => setTimeout(resolve, 500));
					} catch (error) {
						console.error(
							"Error sending stop request via data channel:",
							error
						);
					}
				} else {
					console.warn("Data channel not available for stop request");
				}
			}

			this.cleanup();
			setTimeout(() => {
				this.$router.push({
					name: "ReportAiInterview",
				});
			}, 3000);
		},

		handleInactivityWarning(message) {
			this.showInactivityWarning = true;
			this.inactivityCountdown = 60;
			this.startInactivityCountdown();
		},

		handleInactivityDisconnect(message) {
			this.showInactivityWarning = false;
			this.endCall();
		},

		startInactivityCountdown() {
			this.clearInactivityTimer();

			this.inactivityCountdownInterval = setInterval(() => {
				this.inactivityCountdown--;

				if (this.inactivityCountdown <= 0) {
					this.clearInactivityTimer();
					this.showInactivityWarning = false;
					this.endCall();
				}
			}, 1000);
		},

		clearInactivityTimer() {
			if (this.inactivityCountdownInterval) {
				clearInterval(this.inactivityCountdownInterval);
				this.inactivityCountdownInterval = null;
			}
		},

		dismissInactivityWarning() {
			this.showInactivityWarning = false;
			this.clearInactivityTimer();
			this.inactivityCountdown = 60;

			if (
				this.clientDataChannel &&
				this.clientDataChannel.readyState === "open"
			) {
				try {
					console.log("Sending presence confirmation to interviewer...");
					this.clientDataChannel.send(
						JSON.stringify({ type: "user_presence_confirmed" })
					);
					console.log("Presence confirmation sent successfully");
				} catch (error) {
					console.error("Error sending presence confirmation:", error);
				}
			} else {
				console.warn("Data channel not available for presence confirmation");
			}
		},

		async getUserAvatar() {
			const initials = this.getInitials(this.userInfo.username);
			try {
				const res = await getParticipantAvatar(initials);
				this.userAvatar = res.data.data.link;
			} catch (error) {
				console.error("Error fetching user avatar:", error);
			}
		},

		getInitials(name) {
			if (!name) return "AB";
			let names = name.split(" ");
			return names.length === 1
				? (names[0].charAt(0) + names[0].charAt(1)).toUpperCase()
				: (
						names[0].charAt(0) + names[names.length - 1].charAt(0)
				  ).toUpperCase();
		},

		cleanup() {
			console.log("Cleaning up...");

			const localVideo = document.getElementById("localVideo");
			if (localVideo) {
				localVideo.srcObject = null;
			}

			const remoteVideo = document.getElementById("remoteVideo");
			if (remoteVideo) {
				remoteVideo.srcObject = null;
			}

			if (this.call) {
				this.call.close();
			}

			if (this.localStream) {
				this.localStream.getTracks().forEach((track) => {
					track.stop();
				});
			}

			if (this.remoteStream) {
				this.remoteStream.getTracks().forEach((track) => {
					track.stop();
				});
			}

			if (this.peer) {
				this.peer.destroy();
			}

			this.stopAudioPlayback();
			this.stopPerformanceNowInterval();

			this.clientDataChannel = null;
			this.transcripts = [];
			this.remoteStreamConnected = false;
			this.clearInactivityTimer();
		},
		formatTime(time) {
			const totalSeconds = Math.floor(time);
			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;
			return `${minutes.toString().padStart(2, "0")}:${seconds
				.toString()
				.padStart(2, "0")}`;
		},
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		formattedTime() {
			if (
				this.initialElapsedMs !== null &&
				this.startTime !== null &&
				this.performanceNow !== null
			) {
				const currentElapsedMs =
					this.initialElapsedMs + (this.performanceNow - this.startTime);
				return this.formatTime(Math.max(0, currentElapsedMs / 1000));
			}
			return "00:00";
		},
		showLoaderModal() {
			return [
				this.MOCK_INTERVIEW_STATUS.INITIALZING,
				this.MOCK_INTERVIEW_STATUS.COMPLETED,
			].includes(this.mockInterviewStatus);
		},
		loaderText() {
			return this.mockInterviewStatusText[this.mockInterviewStatus];
		},
		MOCK_INTERVIEW_STATUS() {
			return {
				INITIALZING: 0,
				ONGOING: 1,
				COMPLETED: 2,
			};
		},
		formattedCountdown() {
			const minutes = Math.floor(this.inactivityCountdown / 60);
			const seconds = this.inactivityCountdown % 60;
			return `${minutes}:${seconds.toString().padStart(2, "0")}`;
		},
	},
};
</script>

<style>
.timer-class {
	font-size: 16px;
	font-weight: bold;
	background-color: #ffffff;
	color: #000000;
	border: 2px solid #d9e7f7;
	padding: 5px 15px;
	border-radius: 5px;
}
.pb-10 {
	padding-bottom: 10px;
}
.aio-interview-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 60px 15px 60px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
}
.aio-interview-container .cand-header {
	background-color: #20639b14;
}
.aio-container {
	display: flex;
	gap: 20px;
	height: calc(100vh - 148px);
	background: #fdfdfd;
	width: 100%;
	position: relative;
	border-radius: 5px;
	padding: 20px;
	transition: gap 0.5s ease-in-out;
}
.aio-container.no-gap {
	gap: 0;
}
.aio-container .left-box {
	width: 75%;
	height: 100%;
	transition: width 0.5s ease-in-out;
	overflow: hidden;
	display: flex;
	justify-content: center;
	background-color: #383838;
	border-radius: 8px;

	position: relative;
}
.aio-container .left-box.expanded {
	width: 100%;
}
.aio-container .right-box {
	width: 25%;
	height: 100%;
	transition: width 0.5s ease-in-out, opacity 0.5s ease-in-out;
	overflow: hidden;
}
.aio-container .right-box.collapsed {
	width: 0%;
	opacity: 0;
}
.aio-container .left-box article {
	border-radius: 4px;
	overflow: hidden;
	position: relative;
	z-index: 1;
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.left-box .expand {
	position: absolute;
	z-index: 2;
	right: 30px;
	top: 30px;
}
.left-box .control-panel {
	position: absolute;
	z-index: 2;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
	right: 0px;
	bottom: 25px;
}
.left-box .cand-name {
	position: absolute;
	z-index: 2;
	display: flex;
	align-items: center;
	gap: 10px;
	left: 20px;
	bottom: 25px;
	background: #00000099;
	border-radius: 4px;
	padding: 4px 10px;
}
.left-box .bot-name {
	position: absolute;
	z-index: 2;
	display: flex;
	align-items: center;
	gap: 10px;
	left: 15px;
	bottom: 15px;
	background: #00000099;
	border-radius: 4px;
	padding: 4px 10px;
}
.left-box .bot-card {
	position: absolute;
	z-index: 2;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	right: 20px;
	bottom: 25px;
	background: #383838;
	border-radius: 6px;
	box-shadow: 0px 14.6px 44.23px 0px #00000066;
	width: 214px;
	height: 143px;
}
.user-talk-box {
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #ffdd8030;
	border-radius: 16px;
	padding-block: 15px;
}
.user-talk-box.for-left {
	position: absolute;
	padding-inline: 30px;
	bottom: 70px;
	background: #fff9ef;
}
.right-box .right-overflow {
	height: calc(100vh - 190px);
	overflow: auto;
	margin-bottom: 15px;
	padding-right: 5px;
	display: flex;
	flex-direction: column;
	gap: 30px;
}
.right-box .right-overflow .text-box {
	padding: 12px 16px;
	border-radius: 4px 16px 16px 16px;
	font-weight: 500;
	font-size: 16px;
	color: #0d0d0d;
	background-color: #f1f5f9;
}
.aio-container .right-box.collapsed .text-box {
	color: #f1f9f5;
}
.user-name-circle {
	height: 160px;
	width: 160px;
	background-color: #20639b;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
}
.left-box .lap-mob {
	height: 100%;
}
.local-video {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transform: scaleX(-1);
}
.video-cover {
	background: #3c3e43;
	border-radius: 4px;
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0px;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: hidden;
}
.avatar-container {
	position: relative;
	width: 25%;
	aspect-ratio: 1;
	display: flex;
	justify-content: center;
	align-items: center;
}
.user-avatar {
	width: 100%;
	height: 100%;
	border-radius: 50%;
	object-fit: cover;
}
.bot-avatar-container {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
}
.remote-video {
	width: 100%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	top: 0;
	left: 0;
	border-radius: 6px;
}
@media (max-width: 1028px) {
	.aio-interview-container {
		background-color: #f5f9ff;
		height: 100dvh !important;
		padding: env(safe-area-inset-top) 0px env(safe-area-inset-bottom) 0px !important;
		overflow: auto !important;
		position: fixed !important;
		top: unset !important;
	}
	.aio-container {
		display: flex;
		flex-direction: column;
		gap: 0px;
		height: 100%;
		background: unset;
		border: unset;
		box-shadow: unset;
		width: 100%;
		position: relative;
		overflow: hidden;
		border-radius: 0px;
		padding: 0;
	}
	.aio-container .left-box {
		width: 100%;
		height: 50%;
		transition: height 0.5s ease-in-out;
		overflow: unset;
		display: flex;
		justify-content: unset;
		background-color: #202124;
		border-radius: 0px;
		position: relative;
		flex-direction: column;
	}
	.aio-container .right-box {
		width: 100%;
		height: 50%;
		transition: height 0.5s ease-in-out, opacity 0.5s ease-in-out;
		overflow: hidden;
		background-color: white;
		padding: 20px;
	}
	.left-box .head {
		padding: 15px;
		border-bottom: 1px solid #434446;
	}
	.user-talk-box.for-left {
		position: fixed;
		padding-inline: unset;
		width: 90%;
		bottom: calc(90px + env(safe-area-inset-bottom));
		box-shadow: 0px 0px 24px 0px #0000001f;
	}
	.left-box .control-panel {
		position: fixed;
		background-color: #fff;
		height: 70px;
		bottom: calc(0px + env(safe-area-inset-bottom));
	}
	.aio-container .left-box article img {
		height: unset !important;
		width: 100%;
	}
	.left-box .lap-mob {
		position: relative;
		height: 100%;
		width: 100%;
		background-color: #3c3e43;
		display: flex;
		align-items: center;
		border-radius: 6px;
	}
	.aio-container .left-box article {
		padding: 15px;
		overflow: unset;
		border-radius: 0;
		height: calc(100% - 52px);
	}
	.left-box .bot-card {
		width: 100px;
		height: 118px;
		bottom: 25px;
		right: 25px;
		box-shadow: 0px 12px 36px -8px #000000;
		z-index: 1;
		transition: all 1s ease;
	}
	.left-box .bot-card .bot {
		height: 48px;
	}
	.avatar-container {
		width: 40%;
	}
	.right-box .right-overflow {
		height: 100%;
		margin-bottom: unset;
		padding-right: unset;
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding-bottom: 70px;
	}
	.aio-container .right-box.collapsed {
		height: 0%;
		opacity: 0;
	}
	.aio-container .left-box.expanded {
		height: calc(100% - 70px);
	}
	.aio-container .left-box.expanded .control-panel {
		background-color: #202124;
	}
	.aio-container .left-box.expanded .bot-card {
		bottom: 25px;
	}
}

.inactivity-modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.85);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	animation: fadeIn 0.3s ease-in;
}

.inactivity-modal {
	background: white;
	border-radius: 20px;
	padding: 20px;
	max-width: 500px;
	width: 90%;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
	text-align: center;
	animation: slideUp 0.3s ease-out;
}
.inactivity-modal .candash-addBtn {
	padding: 10px 32px !important;
}
.inactivity-icon {
	font-size: 50px;
	margin-bottom: 20px;
	animation: pulse 1s ease-in-out infinite;
}

.inactivity-title {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 28px;
	color: #000;
	margin-bottom: 15px;
}

.inactivity-message {
	font-family: "Montserrat", sans-serif;
	font-size: 18px;
	color: #344054;
	font-weight: 500;
	margin-bottom: 30px;
	line-height: 1.5;
}
.countdown-box {
	margin: 30px 0;
	background: #ffc9c936;
	border-radius: 8px;
	width: fit-content;
	display: flex;
	justify-self: center;
}
.countdown-timer {
	font-family: "Montserrat", sans-serif;
	font-size: 24px;
	font-weight: 700;
	color: #eb0002;
	padding: 5px 15px;

	text-shadow: 0 2px 10px rgba(255, 107, 107, 0.3);
	animation: timerPulse 1s ease-in-out infinite;
}

.inactivity-instruction {
	font-family: "Lato", sans-serif;
	font-size: 14px;
	color: #999;
	margin-bottom: 30px;
	font-style: italic;
}

.dismiss-btn {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
	border: none;
	padding: 15px 30px;
	border-radius: 30px;
	font-family: "Montserrat", sans-serif;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
	box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.dismiss-btn:hover {
	transform: translateY(-2px);
	box-shadow: 0 7px 20px rgba(102, 126, 234, 0.4);
}

.dismiss-btn:active {
	transform: translateY(0);
}

@keyframes fadeIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

@keyframes slideUp {
	from {
		transform: translateY(30px);
		opacity: 0;
	}
	to {
		transform: translateY(0);
		opacity: 1;
	}
}

@keyframes pulse {
	0%,
	100% {
		transform: scale(1);
	}
	50% {
		transform: scale(1.1);
	}
}

@keyframes timerPulse {
	0%,
	100% {
		transform: scale(1);
		color: #ff6b6b;
	}
	50% {
		transform: scale(1.05);
		color: #ff4757;
	}
}

@media (max-width: 1028px) {
	.inactivity-modal {
		padding: 30px 20px;
		max-width: 90%;
	}

	.inactivity-icon {
		font-size: 60px;
		margin-bottom: 15px;
	}

	.inactivity-title {
		font-size: 22px;
		margin-bottom: 10px;
	}

	.inactivity-message {
		font-size: 14px;
		margin-bottom: 20px;
	}

	.countdown-timer {
		font-size: 48px;
		margin: 20px 0;
	}

	.inactivity-instruction {
		font-size: 13px;
		margin-bottom: 20px;
	}

	.dismiss-btn {
		padding: 12px 25px;
		font-size: 14px;
	}
}
</style>
